export var ITokenVersion;
(function (ITokenVersion) {
    ITokenVersion["V3"] = "v3";
})(ITokenVersion || (ITokenVersion = {}));
export var IDcId;
(function (IDcId) {
    IDcId["UNKNOWN_DC"] = "";
    IDcId["ONE"] = "1";
    IDcId["TWO"] = "2";
})(IDcId || (IDcId = {}));
export const YouPayKeys = ['AMOUNT_PAYABLE', 'AMOUNT_PAYABLE_NOW', 'TOTAL_PAYABLE'];
export var WALLET_LINKED_STATUS;
(function (WALLET_LINKED_STATUS) {
    WALLET_LINKED_STATUS["LINKED"] = "LINKED";
    WALLET_LINKED_STATUS["LINK_EXPIRED"] = "LINK_EXPIRED";
    WALLET_LINKED_STATUS["NOT_LINKED"] = "NOT_LINKED";
})(WALLET_LINKED_STATUS || (WALLET_LINKED_STATUS = {}));
export var WalletBalanceMessageType;
(function (WalletBalanceMessageType) {
    WalletBalanceMessageType["INFO"] = "INFO";
    WalletBalanceMessageType["ERROR"] = "ERROR";
    WalletBalanceMessageType["OFFER"] = "OFFER";
})(WalletBalanceMessageType || (WalletBalanceMessageType = {}));
